import React, { useEffect, useState } from 'react';
import classes from "./ConfirmationPage.module.css";
import Header from '../components/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { login } from '../http/http';
import { useDispatch } from 'react-redux';
import { setUserToken } from '../store/slices/userTokenSlice';
import { toast } from 'react-toastify';
import SmallLoader from '../components/Loaders/SmallLoader';
import { useTranslation } from 'react-i18next';

const ConfirmationPage = () => {

    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [msisdn, setMsisdn] = useState(null);
    const [extRef, setExtRef] = useState(null);
    const [pack,setPack]=useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        if (location?.state?.msisdn) {
            setMsisdn(location?.state?.msisdn);
            // setExtRef(location?.state?.extRef);
            setPack(location?.state?.pack);
        }
        else {
            navigate("/");
        }
    }, [location]);

    const handleFormSubmission = async () => {
        try {
            setLoading(true);

            // const response = await confirmSubAPI(msisdn, extRef);
            // setLoading(false);

            // if (response?.data?.status == 4) {
            //     toast.success(t("90"));
            // }

            // if (response?.data?.status == 3) {
            //     setLoading(false);
            //     toast.success(t("91"))
            //     return;
            // }

            await login({ msisdn: msisdn })
                .then((res) => {
                    setLoading(false);
                    dispatch(setUserToken(res?.data?.result?.token));
                    navigate("/home", { replace: true, state: null });
                    toast.success(t("84"));
                })
                .catch((err) => {
                    setLoading(false);
                    toast.error(t("92"));
                });
        } catch (error) {
            setLoading(false);
            if (error?.response?.data?.status == 0) {
                toast.error(t("93"));
            }
            else if (error?.response?.data?.status == 1) {
                toast.error(t("94"));
            }
            else {
                toast.error(t("86"));
            }
        }
    }

    return (
        <>
            <Header />
            <div className={classes.container}>
                <div className={classes.description}>
                    <h2 className={classes.title}>{t("76")}</h2>
                    <p className={classes.text}>
                        {t("77")} <span className={classes.bold}>{pack==="Daily" ? t("106") : t("107")}</span>.{" "}
                        {t("79")}
                    </p>
                </div>

                <div className={classes.buttons_container}>
                    <button type='button' disabled={loading} className={classes.button} onClick={handleFormSubmission}>
                        {loading ? <SmallLoader /> : t("80")}
                    </button>
                    <button type='button' disabled={loading} className={classes.no_button} onClick={() => navigate("/")}>
                        {t("81")}
                    </button>
                </div>
            </div>
        </>

    )
}

export default ConfirmationPage